import styled, { css } from 'styled-components';
import _Image from 'next/image';

export type TitleProps = {
  $type: 'learn' | 'immerse' | 'communicate';
};

export const Card = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.sz.s2} ${theme.sz.s05};

    @media (min-width: ${theme.sz.md}) {
      width: 352px;
      padding: ${theme.sz.s0} ${theme.sz.s05};
    }
  `,
);

export const Title = styled.div<TitleProps>(
  ({ theme, $type }) => css`
    ${theme.typography.heading.desktop.m}
    text-align: center;

    ${
      $type === 'learn' &&
      css`
        color: ${theme.co.success40};
      `
    }

    ${
      $type === 'immerse' &&
      css`
        color: ${theme.co.tertiary50};
      `
    }

    ${
      $type === 'communicate' &&
      css`
        color: ${theme.co.error60};
      `
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    text-align: center;
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.large};
    padding: ${theme.sz.s2} ${theme.sz.s8};

    @media (min-width: ${theme.sz.md}) {
      padding: ${theme.sz.s0};
    }
  `,
);

export const Image = styled(_Image)`
  max-width: 100%;
  height: auto;
`;
